import React from 'react'
import className from "classnames"
export default function Title({children, primary, primary2, primary3,secondary}) {

    const classes =className('',{
        'text-amber font-cairo-regular text-2xl md:text-4xl font-bold':primary,
        'text-amber font-cairo-semibold text-base md:text-3xl':primary3,
        'text-amber font-reem-kufi-bold text-2xl md:text-4xl':primary2,
        'font-reem-kufi-semibold text-3xl': secondary,
    })

  return (
    <div className={classes}>
      {children}
    </div>
  )
}
